import {useNavigate} from "react-router-dom";
import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import {config} from "./config.tsx";
import {tableApiFunc} from "@/utils/data.ts";
import {queryMemberInfoListByPage, queryMemberLevelList, saveOrUpdateMemberEventDetail} from "@/services/member.ts";
import {openEdit} from "./edit.tsx";
import {useRef} from "react";
import {message} from "antd";
import {downloadExcel} from "@/services/evaluateConfig.ts";

/**
 *
 * 会员等级
 * @constructor
 */
function Page() {
    const navigate = useNavigate()
    const tableRef: any = useRef()
    const history = useNavigate()

    const onAddOrEdit = (data: any, option?: any) => {
        openEdit({
            title: option.title,
            data: {memberId: data.id, type: option.type},
            submit: saveOrUpdateMemberEventDetail,
            destroy: (success) => {
                if (success) {
                    tableRef.current.reload();
                }
            }
        });
    }
    const onExport = () => {
        const pagination = tableRef.current?.getPagination?.();
        const searchParams = tableRef.current?.getSearch?.()?.getFieldsValue?.();
        const dataQuery = {
            current: pagination?.current ?? 1,
            pageSize: pagination?.pageSize ?? 10,
            ...searchParams
        }

        const data = {
            "taskName": "会员信息导出",
            "reqParam": JSON.stringify(dataQuery),
            "taskCode": "MembeInfoExcelImpl",
            "taskSource": "MEMBER",
            "taskRemark": "会员信息导出"
        }
        message.loading({content: '导出中'})
        downloadExcel(data)
            .then(() => {
                history('/main/download');
            })
            .catch(() => {
                message.error('导出失败')
            })
    }
    const getStatusOptions = async () => {
        const levelList = await queryMemberLevelList({});
        return Promise.resolve({
            levelList
        })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberInfoListByPage, {
                paginationInBody: true,
                fieldNames: {current: 'current'},
            }),
            getStatusOptions,
        },
        events: {onExport},
        customRender: {
            actionRender(_: null, record: Record<string, any>) {
                return (
                    <STableActions>
                        <SActionBtn
                            onClick={() => navigate(`/config/member/user/details?id=${record.id}`)}>详情</SActionBtn>
                        <SActionBtn onClick={() => onAddOrEdit(record, {title: '积分', type: 1})}>积分补发</SActionBtn>
                        <SActionBtn
                            onClick={() => onAddOrEdit(record, {title: '成长值', type: 2})}>成长值补发</SActionBtn>
                    </STableActions>
                )
            }
        }
    }
    return (
        <div>
            <div style={{display: 'flex'}}>
                <SLowcodeList
                    searchMode={'group'}
                    config={config}
                    ref={tableRef}
                    {...extensions}
                />
            </div>
        </div>
    );
}

export default Page;
